import PropTypes from 'prop-types';

// Common scalar / primitive reusable props
export const idProp = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

// Communication style (array of colour/value objects)
export const communicationStyleEntryShape = PropTypes.shape({
  color: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
});
export const communicationStyleArray = PropTypes.arrayOf(communicationStyleEntryShape);

// Job shape (minimal)
export const jobShape = PropTypes.shape({
  title: PropTypes.string,
});

// Base user shape object (not yet wrapped in PropTypes.shape, for easy spreading)
export const userBaseShape = {
  id: idProp,
  name: PropTypes.string.isRequired,
  pronouns: PropTypes.string,
  picture: PropTypes.string,
  job: jobShape,
  communication_style_sorted: communicationStyleArray,
  deleted_at: PropTypes.string,
};

// Full user PropType (non-required id to match current usages)
export const userShape = PropTypes.shape(userBaseShape);

// Minimal user (commonly for selects / authors etc.)
export const userMinimalShape = PropTypes.shape({
  id: idProp.isRequired,
  name: PropTypes.string.isRequired,
});

// Active user (adds permission helper)
export const activeUserShape = PropTypes.shape({
  ...userBaseShape,
  isInGroup: PropTypes.func,
});

// Generic react-select option shape
export const selectOptionShape = PropTypes.shape({
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  value: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
});

// Generic array-of-id objects (used in multi-select value props)
export const idObjectArray = PropTypes.arrayOf(PropTypes.shape({ id: idProp.isRequired }));

// Note shape (for Notes & Note component)
export const noteShape = PropTypes.shape({
  id: idProp.isRequired,
  display_note: PropTypes.string.isRequired,
  deletable: PropTypes.bool,
  author: userMinimalShape.isRequired,
  created_at: PropTypes.string.isRequired,
});

// Skill shape (basic)
export const skillShapeBasic = PropTypes.shape({
  id: idProp.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
});

// Export grouped for convenience import { shapes } pattern
export const shapes = {
  idProp,
  communicationStyleEntryShape,
  communicationStyleArray,
  jobShape,
  userBaseShape,
  userShape,
  userMinimalShape,
  activeUserShape,
  selectOptionShape,
  idObjectArray,
  noteShape,
  skillShapeBasic,
};

export default shapes;
